var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.12 379.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #344c60;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m342.45,105.88h-10.33c-6.1-36.05-37.46-63.52-75.25-63.52-9.39,0-18.39,1.71-26.7,4.81-14.37-23.77-40.46-39.67-70.27-39.67-45.31,0-82.05,36.73-82.05,82.05,0,5.59.56,11.05,1.63,16.33h-6.82c-35.99,0-65.17,29.18-65.17,65.17s29.18,65.17,65.17,65.17h269.78c35.99,0,65.17-29.18,65.17-65.17s-29.18-65.17-65.17-65.17Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.33,
    y1: 275.45,
    x2: 63.06,
    y2: 362.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.46,
    y1: 285.45,
    x2: 120.2,
    y2: 372.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 207.6,
    y1: 275.45,
    x2: 177.33,
    y2: 362.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 321.88,
    y1: 275.45,
    x2: 291.61,
    y2: 362.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 264.74,
    y1: 285.45,
    x2: 234.47,
    y2: 372.36
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.c91278aa1689fd81f856bab3b2494a12.svg";
export { ForwardRef as ReactComponent };